import { parseDate } from './utils'

export const CONTACT_RESULT = {
	SUCCESS: 1,
	NOT_AVAILABLE: 4,
}

export default class ProcessForwardingCallHistory {
	static fromJSON(json) {
		return new ProcessForwardingCallHistory(
			json.creationDate,
			json.contactResult
		)
	}

	constructor(creationDate, contactResult) {
		this.date = creationDate ? parseDate(creationDate) : {}
		this.success = contactResult.id === CONTACT_RESULT.SUCCESS
	}
}
